import { render, staticRenderFns } from "./ComprasHYGGE.vue?vue&type=template&id=0178e67a&"
import script from "./ComprasHYGGE.vue?vue&type=script&lang=js&"
export * from "./ComprasHYGGE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports